import { BaseAPI, buildTree } from './base';
import type { DepartmentItem } from '../../types/entity/department';
import apiClient from '../apiClient';
import type { BaseResponse, ListResponse, PaginationRequest } from '../../types/base.dto';


export class DepartmentAPI extends BaseAPI<DepartmentItem> {
  constructor() {
    super('/departments');
  }

  // Override list to return tree structure
  // Note: BaseAPI returns ListResponse<T>, but for departments we might want the tree directly in items.
  // Or we keep it flat in response and let component build tree?
  // The previous implementation returned tree from `departmentApi.list()`.
  // Components expect `DepartmentItem[]` which are root nodes with children.
  // BaseAPI.list returns `BaseResponse<ListResponse<T>>`.
  // We can't change the return type signature easily if we want to stay compatible with BaseAPI generic.
  // However, we can return a modified ListResponse where items are roots.
  
  async listTree(params?: PaginationRequest): Promise<DepartmentItem[]> {
    const response = await this.list(params);
    if (response.code === 200 && response.data) {
        return buildTree(response.data.items);
    }
    return [];
  }
}

export const departmentApi = new DepartmentAPI();
